import PageCompiler from '@edools/page-compiler'
import lodashCloneDeep from 'lodash.clonedeep'
import lodashIsEmpty from 'lodash.isempty'
import lodashMerge from 'lodash.merge'

const BANNER = PageCompiler.defaults.herosparkBanner

export default (id, options, siblings) => {
  const hsBanner = lodashCloneDeep(BANNER)

  hsBanner.id = 'herospark-banner-id'
  hsBanner.title = 'Banner HeroSpark'
  hsBanner.type = 'HeroSparkBanner'

  hsBanner.id = id
  hsBanner.options.sm.position = siblings.length
  hsBanner.options.md.position = siblings.length
  hsBanner.options.lg.position = siblings.length

  if (!lodashIsEmpty(options)) {
    lodashMerge(hsBanner.options, options)
  }

  return hsBanner
}
